import React from 'react'
import Tr from 'translations/Translations';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

function WorkableIconCheckButton({
	tooltip = Tr('check'),
	...props
}) {
	return <WorkableIconButton
		tooltip={tooltip}
		Icon={CheckCircleOutlineIcon}
		{...props}
	/>
}

WorkableIconCheckButton.propTypes = {
	expanded: PropTypes.bool,
	working: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string,
	hideTooltip: PropTypes.bool,
	color: PropTypes.string,
	onClick: PropTypes.func
}

export default WorkableIconCheckButton;